import { ChevronLeft } from 'lucide-react'

interface BackButtonProps {
  onClick: () => void
  className?: string
  ariaLabel?: string
}

// New back-button styling from the membership-info / cancel-flow redesign.
// Other pages still use `DesktopBackButton` until they're redesigned too.
export function BackButton({
  onClick,
  className = '',
  ariaLabel = 'Back',
}: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`flex size-9 cursor-pointer items-center justify-center rounded-full bg-app-grey-100 text-app-grey-500 transition-colors duration-150 hover:bg-app-grey-200 ${className}`.trim()}
    >
      <ChevronLeft className="size-4" strokeWidth={2.5} />
    </button>
  )
}
